interface DefaultTableState {
  tableData: any[];
  pagination: {
    current: number;
    pageSize: number;
    total: number;
    position: 'top' | 'bottom' | 'both';
    showTotal: (total: any, range: any) => string;
  };
  loading: boolean;
  filters: {};
}

export const defaultTableState: DefaultTableState = {
  tableData: [] as any[],
  pagination: {
    current: 1,
    pageSize: 30,
    total: 0,
    position: 'bottom',
    showTotal: (total, range) => `${range[0]}-${range[1]} van ${total} rijen`
  },
  loading: true,
  filters: {}
};
